import { render, staticRenderFns } from "./CambiarTelefono.vue?vue&type=template&id=21b8b325&scoped=true&"
import script from "./CambiarTelefono.vue?vue&type=script&lang=js&"
export * from "./CambiarTelefono.vue?vue&type=script&lang=js&"
import style0 from "./CambiarTelefono.vue?vue&type=style&index=0&id=21b8b325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8b325",
  null
  
)

export default component.exports